export const SELECTED_ITEM_ALL_ID = -192837;
